import { topHeadlines, sideBriefs } from '@/mocks/news';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function HeadlineSection() {
  const [featured, secondary] = topHeadlines;

  return (
    <section id="headline" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto py-12 md:py-16">
          <SectionHeading
            id="headline"
            kicker="今日头条"
            title="刚刚发生的几条，先看这两个"
            desc="黑料网1最新更新把最热的两条放到台前，其余进展跟着时间线往下走。"
            actionHref="#flash"
            actionLabel="去快讯时间线"
          />

          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
            {/* 主推大图 */}
            <article className="lg:col-span-8 group">
              <a href="#headline" className="block cursor-pointer">
                <div className="w-full aspect-[16/10] overflow-hidden rounded-xl border border-background-200">
                  <img
                    src={featured.image}
                    alt={`黑料网1今日头条：${featured.title}`}
                    title={`${featured.title} - 黑料网1`}
                    className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-500"
                  />
                </div>
              </a>
              <div className="mt-5">
                <div className="flex flex-wrap items-center gap-3 text-xs">
                  <span className="inline-flex items-center gap-1 h-7 px-2.5 rounded-md bg-primary-500 text-background-50 font-medium">
                    <i className="ri-fire-line" aria-hidden="true"></i>
                    {featured.tag}
                  </span>
                  <span className="text-foreground-500">{featured.time}</span>
                  <span className="flex items-center gap-1 text-foreground-500">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    {featured.heat}
                  </span>
                </div>
                <h5 className="mt-3 font-heading text-xl md:text-2xl font-bold leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
                  <a href="#headline" className="cursor-pointer">
                    {featured.title}
                  </a>
                </h5>
                <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
                  {featured.summary}
                </p>
              </div>
            </article>

            {/* 侧栏 */}
            <div className="lg:col-span-4 flex flex-col gap-5">
              <article className="group">
                <a href="#headline" className="block cursor-pointer">
                  <div className="w-full aspect-[16/9] overflow-hidden rounded-lg border border-background-200">
                    <img
                      src={secondary.image}
                      alt={`黑料网1新料快讯：${secondary.title}`}
                      title={`${secondary.title} - 黑料网1`}
                      className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-500"
                    />
                  </div>
                </a>
                <div className="mt-3">
                  <span className="inline-flex items-center h-6 px-2 rounded bg-accent-100 text-accent-900 text-[11px] font-medium">
                    {secondary.tag}
                  </span>
                  <h5 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
                    <a href="#headline" className="cursor-pointer">
                      {secondary.title}
                    </a>
                  </h5>
                  <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                    <span>{secondary.time}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" aria-hidden="true"></i>
                      {secondary.heat}
                    </span>
                  </div>
                </div>
              </article>

              <div className="rounded-lg border border-background-200 bg-background-100 p-4">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-medium text-foreground-600 tracking-wide">同样值得看</span>
                  <span className="w-6 h-6 flex items-center justify-center rounded text-foreground-400">
                    <i className="ri-list-check-2 text-sm" aria-hidden="true"></i>
                  </span>
                </div>
                <ul className="mt-3 divide-y divide-background-200">
                  {sideBriefs.map((brief) => (
                    <li key={brief.id}>
                      <a
                        href="#flash"
                        className="flex items-start gap-3 py-3 cursor-pointer group"
                      >
                        <span className="mt-0.5 shrink-0 h-6 px-2 inline-flex items-center rounded bg-secondary-100 text-secondary-900 text-[11px]">
                          {brief.tag}
                        </span>
                        <span className="flex-1">
                          <span className="block text-sm text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                            {brief.title}
                          </span>
                          <span className="mt-1 block text-xs text-foreground-500">{brief.time}</span>
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}